import Resource from "./resource";

export class LicenseResource extends Resource {
    LicenseText: string;
    SerialNumber: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/licenseResource.ts